import React from 'react'
import { FormatNumberMXN } from "../../common/Utils";
import Tooltip from '@material-ui/core/Tooltip'
import IconButton from '@material-ui/core/IconButton'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import { Icon } from 'antd';

export const ColumnsOrderDetailReceipt = (t, handleDownloadDocument,onClickDelete,ButtonClass) => (
    [
        {
            name: t('OrderDetailReceipt.ColumnFileName'),
            columnheader: {textAlign: 'center'},
            selector: 'receiptFileNm',
            sortable: true,
            width: "250px",
            cell: row => row.receiptFileNm
        },
        {
            name: t('OrderDetailReceipt.ColumnLoadDate'),
            selector: 'pymtOrdReceiptDt',
            columnheader: {textAlign: 'center'},
            width: "150px",
            sortable: true,
            cell: row => row.pymtOrdReceiptDt
        },
        {
            name: t('OrderDetailReceipt.ColumnService'),
            selector: 'services',
            columnheader: {textAlign: 'center'},
            sortable: true,
            cell: row => row.services.length > 100 ? row.services.substring(0, 100) + " ..." : row.services
        },
        {
            name: t('OrderDetailReceipt.ColumnAmount'),
            selector: 'pymtOrdReceiptTotalAmt',
            columnheader: {textAlign: 'center'},
            sortable: true,
            right: true,
            width: "150px",            
            cell: row => FormatNumberMXN(row.pymtOrdReceiptTotalAmt)
        },
        {
            name: t('OrderDetailReceipt.ColumnStatus'),
            selector: 'ordStatDescription',
            columnheader: {textAlign: 'center'},
            sortable: true,
            width: "150px",            
            cell: row => row.ordStatDescription
        },
        {
            name: "",
            center: true,
            width: '50px',
            cell: row => (buttonForColumns(t, row,onClickDelete))
        },
        {
            name: "",
            center: true,
            width: '50px',
            cell: row => (buttonDownloadForColumns(t, row, handleDownloadDocument,ButtonClass))
        }
    ]
)

const buttonForColumns = (t, row,onClickDelete) => {
    return (
        <div>
            <Tooltip title={t('OrderDetailReceipt.ModalDeleteReceipt.ToolTipLbBtnDelete')}>
                <IconButton style={{ color: row.hasOwnProperty("activeBtnDelete") ? row.activeBtnDelete?'#BF2E2E':'' : '' }} onClick={()=>onClickDelete(row)} disabled={row.hasOwnProperty("activeBtnDelete") ? !row.activeBtnDelete : false}>
                    <DeleteForeverIcon />
                </IconButton>
            </Tooltip>
        </div>
    )
}

const buttonDownloadForColumns = (t, row, handleDownloadDocument,ButtonClass) => {
    return (
        <div>
            <Tooltip title={t('OrderDetailReceipt.DownloadReeiptFee')}>
                <IconButton className={ButtonClass.customButton} onClick={() => handleDownloadDocument(row.pymtOrdReceiptId)}>
                    <Icon type="download" style={{fontSize: '20px'}}/>
                </IconButton>
            </Tooltip>
        </div>
    )
}